import { TYPES, PATH } from "../envs/core";
import Axios from "axios";
import { placesElastic } from "../constants/api";
const a3 = "https://www.antena3.com/noticias/elecciones/resultados/generales/";
const lasexta = "https://www.lasexta.com/noticias/nacional/elecciones-generales/resultados/";
const onda = "https://www.ondacero.es/noticias/elecciones-generales/resultados/";
const a3Val = "https://www.antena3.com/noticias/elecciones/resultados/valencianas/";
const lasextaVal = "https://www.lasexta.com/noticias/nacional/elecciones-comunidad-valenciana/resultados/";
const ondaVal = "https://www.ondacero.es/noticias/elecciones-valencia/resultados/";
export const LOCALHOST = "localhost";
export const LA_SEXTA = "lasexta";
export const ANTENA3 = "antena3";
export const ONDACERO = "ondacero";
export const isOndaCero = site => site === ONDACERO || window.location.hostname.includes(ONDACERO);
export const isAntena3 = site => site === ANTENA3 || window.location.hostname.includes(ANTENA3);
export const isLaSexta = site => site === LA_SEXTA || window.location.hostname.includes(LA_SEXTA);
export const getTitle = (pathType, pathYear, placeName) => {
  switch (pathType) {
    case TYPES.MUNICIPAL:
      return "ELECCIONES  MUNICIPALES DE ".concat(placeName, " ").concat(pathYear);

    case TYPES.REGIONAL:
      // TODO Asumo que regional es valenciana hasta las siguientes elecciones
      //return `ELECCIONES  AUTONÓMICAS DE ${placeName} ${pathYear}`;
      return "ELECCIONES VALENCIANAS";

    case TYPES.EUROPE:
      return "ELECCIONES  EUROPEAS ".concat(pathYear);

    default:
      return "ELECCIONES GENERALES ".concat(pathYear);
  }
};

const navigateByPlace = (place, host, year, type, numElection, val = false) => {
  const isAmp = window.parent.location.host.indexOf("amp") !== -1;
  var goTo = "";

  switch (host) {
    case "antena3":
      goTo = "".concat(val ? a3Val : a3).concat(year, "/").concat(type.toLowerCase(), "/").concat(numElection, "/").concat(place.ineId).concat(place.path);
      window.parent.location.href = isAmp ? goTo.replace("www.", "amp.") : goTo;
      break;

    case "lasexta":
      goTo = "".concat(val ? lasextaVal : lasexta).concat(year, "/").concat(type.toLowerCase(), "/").concat(numElection, "/").concat(place.ineId).concat(place.path);
      window.parent.location.href = isAmp ? goTo.replace("www.", "amp.") : goTo;
      break;

    case "ondacero":
      goTo = "".concat(val ? ondaVal : onda).concat(year, "/").concat(type.toLowerCase(), "/").concat(numElection, "/").concat(place.ineId).concat(place.path);
      window.parent.location.href = isAmp ? goTo.replace("www.", "amp.") : goTo;
      break;

    default:
      break;
  }
};

export const refreshParent = (place, year, type, numElection, scopeChange) => {
  const host = window.location.hostname.replace(/www\./g, "").replace(/amp\./g, "").replace(/\.es/, "").replace(/\.com/, "").replace("localhost", "antena3");

  if (typeof place === "string") {
    Axios.get("".concat(PATH).concat(placesElastic).concat(place)).then(response => {
      return response.data;
    }).then(data => {
      navigateByPlace(data, host, year, type, numElection, place === "R10" && scopeChange);
    });
  } else {
    navigateByPlace(place, host, year, type, numElection, place === "R10" && scopeChange);
  }
};
export const arrayToDict = (array, field = "id") => array.reduce((result, party) => {
  result[party[field]] = party;
  return result;
}, {});
export * from "./hooks";